/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Container } from '@material-ui/core';
import { ContainerProps } from '@material-ui/core/Container';

import styles from './styles';

type PropTypes = Pick<ContainerProps, 'maxWidth'> & {
  className?: string;
};

const PageContainer: React.FC<PropTypes> = props => {
  const { maxWidth, className, children } = props;

  return (
    <Container maxWidth={maxWidth || 'md'}>
      <div css={styles.pageContainer} className={className}>
        {children}
      </div>
    </Container>
  );
};

export default PageContainer;
